import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Raw = ({ options = [], selectedValue, onChange, ...props }) => (
	<select className="form-control" value={selectedValue} onChange={onChange} {...props}>
		{options.map(option => (
			<option key={option.value || option} value={option.value || option}>{option.label || option}</option>
		))}
	</select>
);

Raw.propTypes = {
	options: PropTypes.array,
	selectedValue: PropTypes.any,
	onChange: PropTypes.func
};

const Select = ({ label, labelClassName, ...props }) => (
	<div className="form-group">
		{label && (<label className={cn('control-label', labelClassName)}>{label}</label>)}
		<Raw {...props} />
	</div>
);

Select.propTypes = {
	options: PropTypes.array,
	selectedValue: PropTypes.any,
	onChange: PropTypes.func,
	label: PropTypes.string,
	labelClassName: PropTypes.any
};

export {
	Select as default,
	Raw
};
